import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/business/")({
  beforeLoad: () => {
    throw redirect({ to: "/business/memberOrder" });
  },
});
